module.exports = __webpack_public_path__ + "img/RTF-min.74680fe6.png";